import { createSwiper } from './swiper';

const initSection = (section) => {
  const carousel = section.querySelector('.activity-navigation__swiper');
  if (!carousel) return;

  let instance = null;

  const destroy = () => {
    if (instance) {
      instance.destroy(true, true);
      instance = null;
    }
  };

  instance = createSwiper(carousel, {
    lazy: true,
    slideClass: 'activity-card',
    wrapperClass: 'activity-navigation__cards',
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 0,
    roundLengths: true,
    grabCursor: true,
    navigation: {
      nextEl: carousel.querySelector('.activity-navigation__nav-btn--next'),
      prevEl: carousel.querySelector('.activity-navigation__nav-btn--prev'),
    },
    a11y: { enabled: true },
  });

  return destroy;
};

const activityNavigation = () => {
  const destroyers = new Map();

  document.querySelectorAll('.activity-navigation').forEach((section) => {
    const destroy = initSection(section);
    if (destroy) destroyers.set(section.id, destroy);
  });

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.activity-navigation');
    if (section) {
      const destroy = initSection(section);
      if (destroy) destroyers.set(section.id, destroy);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector('.activity-navigation');
    if (section && destroyers.has(section.id)) {
      destroyers.get(section.id)();
      destroyers.delete(section.id);
    }
  });
};

export default activityNavigation;
